<h1>{{ data.title }}</h1>
<div mat-dialog-content>
	<p *ngFor="let message of data.messages">{{ message }}</p>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="" cdkFocusInitial>OK</button>
</div>
